import RelatedDocuments from './RelatedDocuments';

export default RelatedDocuments;
